<template>
<div id="FastSearchRight">
  <div class="right-name-line">
    <span class="right-name">{{ categoryName }}</span>
    <gjw-switch
        v-if="categoryCode === fanCode"
        class="switch"
        v-model="isSingleSpeed"
        :has-text="true"
        active-text="单速"
        in-active-text="双速"
        :width="50"
        @change="onSpeedChanged"
    />
  </div>
  <div class="performance-search" v-if="curveFormItems.length">
    <curve-search
        ref="curveSearch"
        class="performance-form"
        page-type="fastSearch"
        :speed-control="isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'"
        :curve-form-items="curveFormItems"
        @curve-search="curveDataChange"
        @change-unit="onUnitChange"
    />
  </div>
  <div class="more-search">
    <div class="more-search-title" v-if="showMoreCondition">
      <span class="title-text" @click="collapse = !collapse">高级筛选<i class="arrow-icon el-icon-d-arrow-right" :class="{'collapse': collapse}" /></span>
      <el-divider class="divider-line" />
    </div>
    <div class="more-search-container" :class="{'collapse': collapse}">
      <div class="more-search-content">
        <div v-if="brands.length" class="search-row">
          <div class="label-col">品牌</div>
          <div class="value-col">
          <span
              v-for="item in brands"
              :key="item.brandCode"
              class="option-span"
              :class="{'selected': selectBrand === item.brandCode}"
              @click="handleBrandsClick(item.brandCode)"
          >{{item.brandName}}</span>
          </div>
        </div>
        <div v-for="(item,index) in searchProperties" :key="index" class="search-row">
          <div class="label-col">{{ item.label }}</div>
          <div class="value-col">
          <span
              v-for="v in item.values"
              :key="v.code"
              class="option-span"
              :class="{ 'selected': selectedItems.includes(v.code) }"
              @click="handleOptionClick(item, v)"
          >{{v.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-container">
    <el-button type="primary" class="start-button" size="normal" @click="startSearch">开始选型</el-button>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { switchDataType } from '@/assets/js/dict'
import ProductStrategy from '@/views/products/strategy/ProductStrategy'
import envCodes from '@/assets/js/envCodes'
import GjwSwitch from '@/components/lib/GjwSwitch.vue'
import CurveSearch from '@/views/products/components/CurveSearch'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import { RecordJournal } from '@/core/gcsUtils'
import gcsReplayRecordMixin from '@/mixins/gcsReplayRecordMixin'

export default {
  name: 'FastSearchRight',
  components: { GjwSwitch, CurveSearch },
  mixins: [checkLoginMixin, gcsReplayRecordMixin],
  props: {
    // 当前品类code
    categoryCode: [String, Number],
    // 当前品类name
    categoryName: String,
  },
  data() {
    return {
      fanCode: envCodes.fanCode,
      pumpCode: envCodes.pumpCode,
      collapse: true,
      firstEnter: true,
      isSingleSpeed: true,
      selectBrand: null,
      searchForm: {},
      // 处理后的性能筛选条件的值
      curveSearchValues: [],
      // 处理后的属性筛选条件的值
      propertySearchValues: [],
      items: [],
      selectedItems: [],
    }
  },
  computed: {
    ...mapGetters({
      brands: 'list/brands',
      allProperties: 'list/allProperties',
      aggProperties: 'list/aggProperties',
      fanPumpSearchProperties: 'list/searchProperties',
    }),
    curveFormItems() {
      const speed = this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'
      const data = this.categoryCode === this.fanCode ? speed : this.allProperties
      const getCurveFormItems = ProductStrategy.getCurveFormItems(this.categoryCode, data)
      getCurveFormItems.forEach((v) => {
        if (v.code === 'P000008' || v.code === 'P000007') { v.required = true }
      })
      return getCurveFormItems
    },
    searchProperties() {
      if ([this.fanCode, this.pumpCode].includes(this.categoryCode)) {
        return this.fanPumpSearchProperties
      } else {
        return ProductStrategy.getSearchProperties(this.categoryCode, { aggProperties: this.aggProperties })
      }
    },
    showMoreCondition() {
      return this.curveFormItems.length && (this.searchProperties.length || this.brands.length)
    },
  },
  watch: {
    curveFormItems: {
      handler(newVal) {
        this.collapse = !!newVal.length
      },
      immediate: true,
    }
  },
  created() {
    // 清空store中的数据，防止数据混乱
    this.setCurrentBrands(null)
    this.setSpeedValue('SINGLE_SPEED')
    this.setCurveSearchValues([])
    this.setPropertySearchValues([])
    this.updateUnit({ code: envCodes.fluid, suffix: 'm³/h' })
  },
  methods: {
    ...mapMutations({
      updateUnit: 'pumpList/updateUnit',
      setCurrentBrands: 'fastSearch/setCurrentBrands',
      setSpeedValue: 'fastSearch/setSpeedValue',
      setCurveSearchValues: 'fastSearch/setCurveSearchValues',
      setPropertySearchValues: 'fastSearch/setPropertySearchValues',
    }),
    ...mapActions({
      loadAggProperties: 'list/loadAggProperties',
    }),
    initData() {
      this.searchForm = {}
      this.curveSearchValues = []
      this.propertySearchValues = []
    },
    onSpeedChanged() {
      const payload = {
        gjwCategoryCode: this.categoryCode,
        speedControl: this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'
      }
      this.loadAggProperties(payload)
      this.$refs.curveSearch.clearData()
      this.initData()
    },
    curveDataChange(curveProperties) {
      this.curveSearchValues = curveProperties
    },
    onUnitChange(unitItem) {
      this.updateUnit(unitItem)
    },
    handleBrandsClick(brandCode) {
      this.selectBrand = this.selectBrand === brandCode ? null : brandCode
    },
    handleOptionClick(property, selectValue) {
      // 多选
      const indexs = this.selectedItems.indexOf(selectValue.code)
      if (indexs === -1) {
        this.selectedItems.push(selectValue.code)
      } else {
        this.selectedItems.splice(indexs, 1)
      }

      if (this.propertySearchValues.some((s) => s.code === property.code && s.valueCode === selectValue.code)) {
        this.propertySearchValues = this.propertySearchValues.filter((s) => !(s.code === property.code && s.valueCode === selectValue.code))
      } else {
        const params = {
          ...property,
          parameterType: switchDataType(property.dataType),
          queryType: 'ENUM',
          valueCode: selectValue.code,
          valueName: selectValue.name,
        }
        this.propertySearchValues.push(params)
      }
      console.log('this.propertySearchValues:', this.propertySearchValues)
    },
    async startSearch() {
      const hasInputError = document.querySelector('.input-error')
      // 是否有被校验住的输入框，若没有，则可以开始选型
      if (!hasInputError) {
        // 校验是否登录
        const isLogin = await this.checkLogin()
        if (isLogin) {
          this.setCurrentBrands(this.selectBrand)
          this.setSpeedValue(this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED')
          this.setCurveSearchValues(this.curveSearchValues)
          this.setPropertySearchValues(this.propertySearchValues)
          this.$nextTick(() => {
            // 跳转录制
            const routeInfo = 
                this.categoryCode === this.fanCode 
                  ? { name: 'FanList' } 
                  : this.categoryCode === this.pumpCode 
                    ? { name: 'PumpList' }
                    : { path: `/productList/${this.categoryCode}` }
            RecordJournal('GoToProductListPage', routeInfo)
            // 跳转至相应的品类列表页
            this.$router.push(routeInfo)
          })
        } else {
          this.showLoginDialog()
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.right-name-line{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  line-height: 32px;
}
.right-name{
  font-size: 16px;
  margin-right: 10px;
}
.performance-search{
  margin: 16px 0;
}
.more-search-title{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: @theme-text-secondary;
  .title-text{
    cursor: pointer;
    height: 49px;
    line-height: 49px;
    margin-right: 4px;
    &:hover{
      color: @theme-color;
    }
  }
  .arrow-icon{
    transform: rotateZ(-90deg);
    margin: 0 4px;
    transition: all .3s;
    &.collapse{
      transform: rotateZ(90deg);
    }
  }
  .divider-line{
    flex:1;
  }
}
.more-search-container{
  height: auto;
  overflow: hidden;
  &.collapse{
    height: 0;
  }
  .search-row{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 10px;
  }
  .label-col{
    flex: 0 0 120px;
    width: 120px;
    margin-left: 88px;
    padding: 4px 0;
    font-weight: bold;
  }
  .value-col{
    display: inline-block;
  }
  .option-span{
    display: inline-block;
    padding: 4px 8px;
    margin: 0 2px 2px;
    cursor: default;
    &:hover{
      background: @theme-select-bg;
    }
    &.selected{
      color: @theme-color;
      background: @theme-select-bg;
    }
  }
}
.button-container{
  text-align: center;
  margin-top: 40px;
}
.start-button{
  width: 168px;
  &:hover{
    background: @theme-hover-color;
    border-color: @theme-hover-color;

  }
}
</style>
